import { ApolloLink, GraphQLRequest } from "apollo-link";
import { setContext } from "apollo-link-context";

import i18n from "../../../i18n";

export const languageLink: ApolloLink = setContext(
  // tslint:disable-next-line
  (_: GraphQLRequest, { headers }: any): Promise<any> | any => {
    return {
      headers: {
        ...headers,
        "Accept-Language": i18n.language,
      },
    };
  }
);
